import {
	Component,
	ViewEncapsulation,
	Input,
	EventEmitter,
	Output,
	ElementRef,
} from '@angular/core';
import { FnToasterService } from '../toaster/index';
/**
 * Component used to upload image and show on UI.
 */
@Component({
	selector: 'fn-files-upload',
	templateUrl: 'fn-files-upload-component.html',
	encapsulation: ViewEncapsulation.None,
})
export class FnFileUploadComponent  {
	/**
	 * Input member variable
	 * used to bind with input attribute id
	 */
	@Input() elementID: string;

	@Input() isMultiple: boolean;
	@Input() accept = '*/*';
	@Input() isDisabled: boolean;
	@Input() disableMsg = 'Please connect to cloud service in App Settings';

	/**
	 * EventEmitter emit whenever DELETE ,ADD or Update action perform
	 */
	@Output() selectedFiles = new EventEmitter<Array<File>>();
	/**
	 * FNImageOutputModel Instance Emitted by EventEmitter.
	 */
	/**
	 * Creates an instance of fn img upload and show component.
	 * @param elementRef to get Element ny id.
	 */
	constructor(
		private elementRef: ElementRef,
		private toastrService: FnToasterService
	) {}

	
	/**
	 * Member method to open Image select window to ADD or Update Image
	 */
	browseFile() {
		if (this.isDisabled) {
			this.showErrorMessage();
		} else {
			const inputElement = this.elementRef.nativeElement.querySelector(
				'#' + this.elementID
			);
			inputElement.click();
		}
	}

	/**
	 * member method
	 * called whenever user select Image and emit FNImageOutputObj when ADD or Update Action performed
	 * @param files Array of files that uploaded by user.
	 */
	fileChange(evtTarget: EventTarget|any) {
        let files =  evtTarget.files; //
		if (files.length > 0) {
			this.selectedFiles.emit([...files]);
			this.elementRef.nativeElement.querySelector('#' + this.elementID).value =
				'';
		}
	}

	showErrorMessage() {
		this.toastrService.error(this.disableMsg);
	}
}
